import { Group, } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { useStudentParentsSuspense } from '@features/student-page/sub-features/student-parents/queries'
import { StudentParent } from '@features/student-page/sub-features/student-parents/components/StudentParent'
import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { Suspense } from 'react'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { StudentParentsTab } from '@features/student-page/components/StudentParentsTab'

export const Route = createFileRoute('/_layout/students/$studentNo/parents')({
    component: RouteComponent,
    staticData: {
        crumb: {
            label: 'Parents',
        }
    }
})

function RouteComponent() {

    const { studentNo } = Route.useParams()

    return (
        <QueryErrorBoundary title='Failed to load parents'>
            <Suspense fallback={<LoadingIndicator resource='parents'/>}>
                <StudentParentsTab studentNo={studentNo}/>
            </Suspense>
        </QueryErrorBoundary>
    )
}
